<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="5">
        <el-card style="height: calc(100vh - 389px);">
          <div slot="header" class="card-header"><i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>部门</div>
          <div style="overflow:auto;height: calc(100vh - 279px);">
            <es-org-tree @clickByOrg="loaduserList" @completed="initOrgTree"></es-org-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-card style="height: calc(100vh - 389px);">
          <div slot="header" class="card-header"><i class="el-icon-s-custom"></i>人员</div>
          <div class="es-op-box">
            <el-date-picker style="float: left;width:300px;margin-bottom: 10px;" format="yyyy-MM-dd" v-model="dateTime"
              type="daterange" size="small" class="query" range-separator="至" start-placeholder="计划开始日期起始"
              end-placeholder="计划开始日期结束" clearable @clear="() => { this.dateTime = []; }" @change="() => {
                this.queryObj.pageNum = 1;
                loaduserList(this.selectorgId)
                LoadDepartusers()
                LoadDepartfaulttop()
                LoadDepartinsttop()
                LoadDepartmaintainttop()
                LoadDeparttasktop()
              }">
            </el-date-picker>
          </div>
          <el-table :data="pageData.list" ref="lineTable" border stripe size="mini" height="calc(100vh - 530px)"
            v-loading="loading">
            <el-table-column type="index" label="序号" width="50" align="center">
            </el-table-column>
            <el-table-column prop="accountname" label="姓名" align="center">
            </el-table-column>
            <el-table-column prop="orgName" label="部门" align="center">
            </el-table-column>
            <el-table-column prop="faultcount" label="完成故障" align="center">
            </el-table-column>
            <el-table-column prop="inscount" label="完成巡检" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.inscount != null">{{ scope.row.inscount }}</span>
                <span v-else>0</span>
              </template>
            </el-table-column>
            <el-table-column prop="maincount" label="完成保养" align="center">
            </el-table-column>
            <el-table-column prop="taskcount" label="完成任务" align="center">
            </el-table-column>
            <el-table-column prop="rosteringcount" label="工时" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.rosteringcount != null">{{ (scope.row.rosteringcount / 60).toFixed(2) }}</span>
                <span v-else>0</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageData"
              @change="(cpage) => { this.queryObj.pageNum = cpage; this.loaduserList(this.selectorgId) }">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!--图形部分-->

    <el-row :gutter="15">
      <el-col :span="5">
        <el-card id="dapartuserschart" style="height:260px;margin-top: 10px;">
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-card style="height:260px;margin-top: 10px;">
          <el-row :gutter="15">
            <el-col :span="6">
              <div class="cbottom" id="departfaulttop">
              </div>
            </el-col>
            <el-col :span="6">
              <div class="cbottom" id="departinstop">
              </div>
            </el-col>
            <el-col :span="6">
              <div class="cbottom" id="departmaintainttop">
              </div>
            </el-col>
            <el-col :span="6">
              <div class="cbottom" id="departtasktop">
              </div>
            </el-col>
          </el-row>

        </el-card>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import dateutils from '../../utils/dateutils.js'
export default {
  name: 'userstatistic',
  data () {
    return {
      orgTree: [],
      sysList: [],
      selectorgId: [],
      queryObj: { pageNum: 1, pageSize: 20, starttime: [], endtime: [] },//查询条件       
      pageData: {},
      dateTime: [],
      loading: false,
      departusers: [],
      departfaulttop: [],

      departinsttop: [],
      departmaintainttop: [],
      departtasktop: [],


    }
  },
  methods: {
    //页面初始化
    init () {
      this.dateTime = [dateutils.dateFormat("YYYY-mm-01 00:00:01", new Date()), dateutils.dateFormat("YYYY-mm-dd 23:59:59", new Date())]
      this.loaduserList()
      this.LoadDepartusers()
      this.LoadDepartfaulttop()
      this.LoadDepartinsttop()
      this.LoadDepartmaintainttop()
      this.LoadDeparttasktop()
    },
    //从后台查询线路列表
    loaduserList (orgIds) {

      this.loading = true
      this.selectorgId = orgIds

      this.queryObj.starttime = this.dateTime[0]
      this.queryObj.endtime = this.dateTime[1]
      this.queryObj.pageNum = 1
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(',')
      }
      this.$ajax.get('/buss/statistic/userlist', this.queryObj).then(msg => {
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    initOrgTree (orgTree) {
      this.orgTree = orgTree
    },

    LoadDepartusers () {
      this.$ajax.get('/buss/statistic/departusers',).then(msg => {
        this.departusers = msg
        console.log(this.departusers)
        this.initDepartusersEChart()
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    initDepartusersEChart () {
      let myChart = this.$echarts.init(document.getElementById('dapartuserschart'))
      var colorList = ['#3bafff', '#afa3f5', '#00d488', '#3feed4', '#f1bb4c', '#aff', "rgba(250,250,250,0.5)"];
      var option = {
        title: {
          subtext: '组织分布',
          x: 'center',
          y: '2%',
          textStyle: {
            fontSize: 18,
            fontWeight: 'normal',
            color: ['#333']
          },
          subtextStyle: {
            color: '#f1bb4c',
            fontSize: 16
          },
        },
        grid: {
          bottom: 150,
          left: 0,
          right: '10%'
        },
        legend: {
          show: false,
          orient: 'vertical',
          top: "middle",
          right: "5%",
          textStyle: {
            color: '#f2f2f2',
            fontSize: 25,
          },
          icon: 'roundRect'
        },
        series: [
          // 主要展示层的
          {
            radius: ['39%', '63%'],
            center: ['50%', '60%'],
            type: 'pie',
            itemStyle: {
              normal: {
                color: function (params) {
                  return colorList[params.dataIndex]
                }
              }
            },
            labelLine: {
              normal: {
                show: false,
                length: 5,
                length2: 60,
                lineStyle: {
                  color: '#d3d3d3'
                },
                align: 'right'
              },
              color: "#000",
              emphasis: {
                show: false
              }
            },
            label: {
              normal: {
                formatter: function (params) {
                  var str = params.name + params.value;
                  return str
                },
                padding: [0, -90],
                height: 35,
              }
            },
            data: this.departusers,
          },
          // 边框的设置
          {
            radius: ['58%', '65%'],
            center: ['50%', '60%'],
            type: 'pie',
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            animation: false,
            tooltip: {
              show: false
            },
            itemStyle: {
              normal: {
                color: 'rgba(250,250,250,0.5)'
              }
            },
            data: [{
              value: 1,
            }],
          }
        ]
      };
      myChart.setOption(option)
    },
    LoadDepartfaulttop () {
      this.$ajax.get('/buss/statistic/departfaulttop', this.queryObj).then(msg => {
        this.departfaulttop = msg
        this.initDepartfaulttopEChart(this.departfaulttop, "departfaulttop", "完成故障TOP10")
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    initDepartfaulttopEChart (datelist, idname, title) {
      let myChart = this.$echarts.init(document.getElementById(idname))
      let names = [];

      for (var i = 0; i < datelist.length; i++) {
        names.push(datelist[i].name)
      }
      var option = {
        "title": {
          "text": title,
          "textStyle": {
            "color": "#bcbfff",
            "fontWeight": "bold",
            "fontSize": 14
          },
          "top": "0%",
          "left": "30%"
        },
        "tooltip": {
          "trigger": "axis",
          "axisPointer": { // 坐标轴指示器，坐标轴触发有效
            "type": "shadow" // 默认为直线，可选为："line" | "shadow"
          }
        },
        "grid": {
          "left": "3%",
          "right": "5%",
          "top": "10%",
          "bottom": "3%",
          "containLabel": true
        },
        "yAxis": [{
          "type": "category",
          "data": names,
          "axisLine": {
            "show": false
          },
          "axisTick": {
            "show": false,
            "alignWithLabel": true
          },
          "axisLabel": {
            "textStyle": {
              "color": "#ffb069"
            }
          }
        }],
        "xAxis": [{
          "type": "value",
          "axisLine": {
            "show": false
          },
          "axisTick": {
            "show": false
          },
          "axisLabel": {
            "show": false
          },
          "splitLine": {
            "show": false
          }
        }],
        "series": [{
          "name": "完成数:",
          "type": "bar",
          "data": datelist,
          "barCategoryGap": "85%",

          "itemStyle": {
            "normal": {
              "color": new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                "offset": 0,
                "color": "#ffb069" // 0% 处的颜色
              }, {
                "offset": 1,
                "color": "#ec2e85" // 100% 处的颜色
              }], false)
            }
          }
        }]
      };
      myChart.setOption(option)
    },

    LoadDepartinsttop () {
      this.$ajax.get('/buss/statistic/departinstop', this.queryObj).then(msg => {
        this.departinstop = msg
        //this.initDepartlineEChart(this.departinstop,"departinstop","完成巡检TOP10")
        this.initDepartfaulttopEChart(this.departinstop, "departinstop", "完成巡检TOP10")
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })

    },

    LoadDepartmaintainttop () {
      this.$ajax.get('/buss/statistic/departmaintainttop', this.queryObj).then(msg => {
        this.departmaintainttop = msg
        // this.initDepartlineEChart(this.departmaintainttop,"departmaintainttop","完成保养TOP10")
        this.initDepartfaulttopEChart(this.departmaintainttop, "departmaintainttop", "完成保养TOP10")
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })

    },

    LoadDeparttasktop () {
      this.$ajax.get('/buss/statistic/departtasktop', this.queryObj).then(msg => {
        this.departtasktop = msg
        //this.initDepartlineEChart(this.departtasktop,"departtasktop","完成任务TOP10") 
        this.initDepartfaulttopEChart(this.departtasktop, "departtasktop", "完成任务TOP10")
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })

    },

    initDepartlineEChart (datelist, idname, title) {

      console.log(datelist)
      console.log(idname)

      let myChart = this.$echarts.init(document.getElementById(idname))

      let names = []
      let datechart = []
      for (var i = 0; i < datelist.length; i++) {
        names.push(datelist[i].name)
        datechart.push(datelist[i].value)
      }

      var option = {
        title: {
          "text": title,
          "textStyle": {
            "color": "#bcbfff",
            "fontWeight": "bold",
            "fontSize": 14
          },
          "top": "0%",
          "left": "30%"
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: names
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        },
        series: [
          {
            name: '完成',
            type: 'line',
            data: datechart,
            itemStyle: {
              normal: {
                color: '#AAF487',
                shadowBlur: 2,
                shadowColor: "rgba(0, 0, 0, .12)",
                shadowOffsetX: 2,
                shadowOffsetY: 2
              }
            },
            markPoint: {
              data: [
                { type: 'max', name: '最大值' },
                { type: 'min', name: '最小值' }
              ]
            },
            markLine: {
              data: [
                { type: 'average', name: '平均值' }
              ]
            }
          }
        ]
      };
      myChart.setOption(option)
    },
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
.cbottom {
  width: 100%;
  height: 260px;
}
</style>
